import { useState, useEffect } from 'react';

export function useAuthUser(){
  let [authUser, setAuthUser] = useState(null)

  const cacheUser = () => {
    if(authUser) return { ...authUser }

    let op = localStorage.getItem("nx_op")
    
		if(!op) {
      let cent = localStorage.getItem("nx_cent")
      if(cent) {
        let authUser1 = JSON.parse(cent)
        setAuthUser(authUser1)
        return;
      } else {
        setAuthUser({})
        return;
      }
    };

		let authUser1 = JSON.parse(op)
    setAuthUser(authUser1)
  }

  cacheUser();

  if(authUser) return { ...authUser }

  return { ...authUser }
}